module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-DA4_1.3f377ae4.jpg";